import { useUserList } from '../api/users';

interface UserSelectorProps {
  value: string | null;
  onChange: (userId: string | null) => void;
  allowUnassign?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
  unassignedLabel?: string;
  allLabel?: string;
}

export function UserSelector({
  value,
  onChange,
  allowUnassign = true,
  disabled,
  placeholder,
  className = '',
  id,
  unassignedLabel = '– Nicht zugewiesen –',
  allLabel,
}: UserSelectorProps) {
  const { data, isLoading } = useUserList({ isActive: true, limit: 100 });
  const users = data?.data ?? [];

  return (
    <select
      id={id}
      value={value ?? ''}
      disabled={disabled || isLoading}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === '' ? null : v);
      }}
      className={`block w-full rounded-md border-gray-300 text-sm focus:border-primary-500 focus:ring-primary-500 disabled:bg-gray-50 disabled:text-gray-500 ${className}`}
    >
      {allowUnassign && (
        <option value="">{allLabel ?? unassignedLabel}</option>
      )}
      {!allowUnassign && placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {users.map((u) => (
        <option key={u.id} value={u.id}>
          {u.firstName} {u.lastName}
        </option>
      ))}
    </select>
  );
}
